module.exports = function (methodName, numArgs) {
  return numArgs == 1 ? function (object, arg) {
    return object[methodName](arg);
  } : function (object, arg1, arg2) {
    return object[methodName](arg1, arg2);
  };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/caller.js
// module id = 444
// module chunks = 142